import { notification } from "antd";
import { useCallback } from "react";

import { useAppDispatch } from "@/hooks/redux";
import useAsyncAction from "@/hooks/useAsyncAction";
import { safeReset } from "@/store/actions";
import { updateOfflineStatus } from "@/store/slices/offline";
import { isOnline } from "@/utils/network/isOnline";

export const useResetApp = () => {
    const dispatch = useAppDispatch();

    const [handleReset, resetLoading] = useAsyncAction(
        useCallback(async () => {
            const online = await isOnline();

            if (!online) {
                dispatch(updateOfflineStatus(true));

                notification.error({
                    message: "Відсутня мережа, додаток перейшов у режим офлайн",
                });
                return;
            }

            dispatch(safeReset());
            // window.location.href = `/profile?reset=${createUniqueId()}`;
        }, [dispatch]),
    );

    return { handleReset, resetLoading };
};
